import { internalErrorBusinessComp } from '../../../../../Components/InternalError/InternalError';
import AssociationObjectList, {
  IAssociationListConfig,
} from './AssociationObjectList/AssociationObjectList';
import {
  IObjektVy,
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../Types/ObjektVy';
import {
  IClientBusinessModel,
  IClientAssociationModel,
} from '../../../../../Types/ClientModelTypes';
import {
  findCollection,
  getAssociations,
} from '../../../../../Model/avenyModelUtils';
import { collectionMap } from '../../../../../Model/ModelContext/ModelContext';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';

const zeroOrOneFilter = (asmod: IClientAssociationModel) =>
  asmod.JoinAssociation;

/** skapar en vy som visar en lista av associerade objekt */
export const associeradObjektListVy = (
  collectionName: string,
  /** kan innebhålla customDefaultColumns */
  config?: IAssociationListConfig
): IObjektVy => ({
  type: 'ObjektVy',
  id: `${collectionName}associationObjectList`,
  info: { komponentMedRubrik: config && config.noCaption },
  def: (businessModel: IClientBusinessModel): IObjektVyComp => {
    const collection = findCollection(
      collectionMap,
      businessModel.CollectionName
    );
    if (collection) {
      const associationObjects =
        getAssociations(collection).filter(zeroOrOneFilter);
      return {
        caption: 'AssociationsObjekt',
        comp: (props: IBusinessCollectionProps) => (
          <AssociationObjectList
            collectionName={businessModel.CollectionName}
            associationObjects={associationObjects}
            ownId={selectedId(props.id)}
            config={config || {}}
          />
        ),
      };
    }
    return {
      caption: `${collectionName} - associationObjectList fel`,
      comp: internalErrorBusinessComp(
        'c6e7051d-7fb0-4559-8e20-607d279adefd',
        `${collectionName} associationObjectList saknas`
      ),
    };
  },
});

export default associeradObjektListVy;
